(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-marquee')) {
    customElements.define(
      'announcement-marquee',
      class AnnouncementMarquee extends HTMLElement {
        connectedCallback() {
          const track = this.firstElementChild;
          if (!track || this.hasAttribute('duplicated')) return;

          const copy = track.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');

          // Ids and theme editor hooks must not appear twice, or the editor
          // cannot tell which node a block belongs to.
          for (const node of copy.querySelectorAll('*')) {
            node.removeAttribute('id');

            for (const attribute of [...node.attributes]) {
              if (attribute.name.startsWith('data-shopify')) {
                node.removeAttribute(attribute.name);
              }
            }
          }

          this.append(copy);
          this.setAttribute('duplicated', '');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class CartDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onCartAdd = this.onCartAdd.bind(this);

          // The header's cart link lives in another section, so opening is
          // delegated from the document rather than bound to the link.
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('cart:add', this.onCartAdd);

          this.addEventListener('click', (event) => this.onClick(event));
          this.addEventListener('submit', (event) => this.onSubmit(event));
          this.addEventListener('input', (event) => this.onInput(event));

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });

          // Coming back from checkout through the back/forward cache restores
          // the page as it was left, spinner included.
          window.addEventListener('pageshow', () => {
            this.querySelectorAll('[aria-busy]').forEach((element) => element.removeAttribute('aria-busy'));
          });
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('cart:add', this.onCartAdd);
          clearTimeout(this.noteTimer);
        }

        open() {
          if (!this.dialog.open) this.dialog.showModal();
        }

        close() {
          this.dialog.close();
        }

        onDocumentClick(event) {
          if (!event.target.closest('[data-cart-toggle]')) return;
          event.preventDefault();
          this.open();
        }

        // A product form has already added the item and asked for this section
        // in the same request; all that is left is to show the result.
        onCartAdd(event) {
          this.render(event.detail?.sections?.[this.dataset.sectionId]);
          this.open();
        }

        onClick(event) {
          if (event.target.closest('[data-cart-close]')) {
            this.close();
            return;
          }

          const change = event.target.closest('[data-cart-change]');
          if (!change) return;

          event.preventDefault();
          this.request(
            `${this.dataset.cartChangeUrl}.js`,
            { id: change.dataset.key, quantity: Number(change.dataset.quantity) },
            change
          );
        }

        onSubmit(event) {
          // Checkout is a real navigation; it only spins until the page leaves.
          if (event.target.matches('[data-cart-checkout]')) {
            event.submitter?.setAttribute('aria-busy', 'true');
            return;
          }

          const form = event.target.closest('[data-cart-add]');
          if (!form) return;

          event.preventDefault();
          const data = new FormData(form);
          this.request(
            `${this.dataset.cartAddUrl}.js`,
            { items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 }] },
            event.submitter || form.querySelector('[type="submit"]')
          );
        }

        // The note is saved as the customer types, without re-rendering, so the
        // field keeps its focus and caret. It is also inside the checkout form,
        // so a note typed a moment before checking out still goes with it.
        onInput(event) {
          if (!event.target.matches('[data-cart-note]')) return;

          clearTimeout(this.noteTimer);
          const note = event.target.value;
          this.noteTimer = setTimeout(() => {
            fetch(`${this.dataset.cartUpdateUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ note }),
            }).catch(() => {});
          }, 400);
        }

        // `trigger` is the control that was pressed. It spins while the whole
        // drawer stops taking clicks; a successful render replaces both.
        async request(url, body, trigger) {
          const content = this.querySelector('[data-cart-content]');
          content?.setAttribute('aria-busy', 'true');
          trigger?.setAttribute('aria-busy', 'true');

          try {
            const response = await fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                ...body,
                sections: this.dataset.sectionId,
                sections_url: window.location.pathname,
              }),
            });
            const json = await response.json().catch(() => ({}));

            if (!response.ok) {
              throw new Error(json.description || json.message || this.dataset.labelError);
            }

            this.render(json.sections?.[this.dataset.sectionId]);
            if (content?.isConnected) content.removeAttribute('aria-busy');
            trigger?.removeAttribute('aria-busy');
          } catch (error) {
            content?.removeAttribute('aria-busy');
            trigger?.removeAttribute('aria-busy');
            this.showError(error.message || this.dataset.labelError);
          }
        }

        render(html) {
          if (!html) return;

          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-content]');
          const current = this.querySelector('[data-cart-content]');
          if (!next || !current) return;

          // The control that was pressed is replaced along with everything
          // else, so focus is carried to its successor by a stable id — or to
          // close, when that line is gone.
          const focusId = document.activeElement?.closest('[data-focus-id]')?.dataset.focusId;
          const scrollTop = current.querySelector('.cart-drawer__body')?.scrollTop ?? 0;

          current.replaceWith(next);

          const body = next.querySelector('.cart-drawer__body');
          if (body) body.scrollTop = scrollTop;

          if (focusId && this.dialog.open) {
            const target = next.querySelector(`[data-focus-id="${CSS.escape(focusId)}"]`) || next.querySelector('[data-cart-close]');
            target?.focus();
          }

          document.dispatchEvent(
            new CustomEvent('cart:change', { detail: { itemCount: Number(next.dataset.itemCount) } })
          );
        }

        showError(message) {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-notification"]) return;
  try {
    
  if (!customElements.get('cart-notification')) {
    customElements.define(
      'cart-notification',
      class CartNotification extends HTMLElement {
        connectedCallback() {
          this.panel = this.querySelector('[data-cart-panel]');
          if (!this.panel) return;

          this.onCartAdd = this.onCartAdd.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);

          document.addEventListener('cart:add', this.onCartAdd);
          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-cart-close]')) this.close();
          });

          // Checkout is a real navigation; it only spins until the page leaves,
          // and the back/forward cache must not bring the spinner back.
          this.addEventListener('submit', (event) => event.submitter?.setAttribute('aria-busy', 'true'));
          window.addEventListener('pageshow', () => {
            this.querySelectorAll('[aria-busy]').forEach((element) => element.removeAttribute('aria-busy'));
          });
        }

        disconnectedCallback() {
          document.removeEventListener('cart:add', this.onCartAdd);
          this.stopListening();
        }

        onCartAdd(event) {
          const { sections, items = [] } = event.detail || {};
          const html = sections?.[this.dataset.sectionId];
          if (!html) return;

          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-content]');
          const current = this.querySelector('[data-cart-content]');
          if (!next || !current) return;

          const keys = new Set(items.map((item) => item.key));
          next.querySelectorAll('[data-line-key]').forEach((line) => {
            line.hidden = !keys.has(line.dataset.lineKey);
          });

          current.replaceWith(next);
          this.open();

          document.dispatchEvent(
            new CustomEvent('cart:change', { detail: { itemCount: Number(next.dataset.itemCount) } })
          );
        }

        open() {
          this.panel.hidden = false;
          this.panel.focus({ preventScroll: true });

          // Deferred a frame, so the click that submitted the form does not
          // reach the outside-click listener and close the panel at once.
          this.stopListening();
          this.listenFrame = requestAnimationFrame(() => {
            document.addEventListener('click', this.onDocumentClick);
            document.addEventListener('keydown', this.onKeydown);
          });
        }

        close() {
          this.panel.hidden = true;
          this.stopListening();
        }

        stopListening() {
          cancelAnimationFrame(this.listenFrame);
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeydown);
        }

        onDocumentClick(event) {
          if (!this.panel.contains(event.target)) this.close();
        }

        onKeydown(event) {
          if (event.key === 'Escape') this.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.details?.querySelector('summary');
      if (!this.details) return;

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.querySelector('form')?.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.querySelector('form')?.removeEventListener('submit', this.onSubmit);
    }

    close() {
      if (!this.details.open) return;
      this.details.open = false;
      this.summary?.focus();
    }

    onClick(event) {
      if (event.target.closest('[data-filters-close]')) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    /* An empty price box would otherwise add `filter.v.price.gte=` to the URL. */
    onSubmit(event) {
      event.currentTarget.querySelectorAll('input[type="number"]').forEach((input) => {
        if (input.value === '') input.disabled = true;
      });
    }
  }

  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', CollectionFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  // The theme editor scrolls to the block a merchant selects. A closed row
  // would hide it, so open the row that was just selected.
  document.addEventListener('shopify:block:select', (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    const row = event.target.closest('details.faq-item');

    if (row) row.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The cart drawer and notification announce the new count after every
  // change, so the header never has to be re-rendered for it.
  document.addEventListener('cart:change', (event) => {
    const count = event.detail?.itemCount;
    if (!Number.isFinite(count)) return;

    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  });

  // The drawer panel is fixed from the header's bottom edge, measured as the
  // toggle is pressed so the panel paints in place on its first frame.
  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target instanceof Element && event.target.closest('.header__drawer-toggle');
      if (!toggle) return;

      const drawer = toggle.parentElement;
      const header = drawer.closest('.header') || drawer;
      const bottom = Math.max(Math.round(header.getBoundingClientRect().bottom), 0);
      drawer.style.setProperty('--drawer-offset', `${bottom}px`);
    },
    { capture: true }
  );

  // The account popup is positioned by Shopify from a CSS variable, so the
  // header's bottom edge is measured as it opens — the announcement bar above
  // and the sticky state both move it.
  document.addEventListener(
    'click',
    (event) => {
      const account = event.target instanceof Element && event.target.closest('.header__account shopify-account');
      if (!account) return;

      const header = account.closest('.header');
      const bottom = Math.max(Math.round(header.getBoundingClientRect().bottom), 0);
      account.style.setProperty('--account-offset', `${bottom}px`);
    },
    { capture: true }
  );

  if (!customElements.get('predictive-search')) {
    customElements.define(
      'predictive-search',
      class PredictiveSearch extends HTMLElement {
        connectedCallback() {
          this.details = this.closest('details');
          this.summary = this.details?.querySelector('summary');
          this.input = this.querySelector('input[name="q"]');
          this.results = this.querySelector('[data-search-results]');
          this.status = this.querySelector('[data-search-status]');
          if (!this.details || !this.input || !this.results) return;

          this.cache = new Map();
          this.position = this.position.bind(this);
          this.onToggle = this.onToggle.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onCartAdd = () => this.close(false);

          // Measured on the click too, because `toggle` fires after the panel
          // has already painted once at the fallback offset.
          this.summary?.addEventListener('click', this.position);
          this.details.addEventListener('toggle', this.onToggle);
          this.details.addEventListener('keydown', this.onKeydown);
          document.addEventListener('cart:add', this.onCartAdd);

          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-search-close]')) this.close();
          });

          this.input.addEventListener('input', () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.search(), 300);
          });
        }

        disconnectedCallback() {
          clearTimeout(this.timer);
          this.controller?.abort();
          document.removeEventListener('cart:add', this.onCartAdd);
          window.removeEventListener('resize', this.position);
        }

        onToggle() {
          if (this.details.open) {
            this.position();
            window.addEventListener('resize', this.position);
            requestAnimationFrame(() => this.input.focus());
            return;
          }

          // Closing starts the next search from scratch, as on 39-bc.com.
          window.removeEventListener('resize', this.position);
          clearTimeout(this.timer);
          this.controller?.abort();
          this.input.value = '';
          this.clear();
        }

        onKeydown(event) {
          if (event.key !== 'Escape' || !this.details.open) return;
          event.preventDefault();
          this.close();
        }

        // After an add to cart the cart surface takes focus, so focus is only
        // handed back to the toggle when the visitor closes the panel.
        close(returnFocus = true) {
          if (!this.details.open) return;
          this.details.open = false;
          if (returnFocus) this.summary?.focus();
        }

        position() {
          const header = this.closest('.header') || this.details;
          const bottom = Math.max(Math.round(header.getBoundingClientRect().bottom), 0);
          this.style.setProperty('--search-offset', `${bottom}px`);
        }

        async search() {
          const query = this.input.value.trim();
          this.controller?.abort();

          if (!query) {
            this.clear();
            return;
          }

          if (this.cache.has(query)) {
            this.render(this.cache.get(query));
            return;
          }

          this.controller = new AbortController();
          this.results.setAttribute('aria-busy', 'true');

          const params = new URLSearchParams({
            q: query,
            section_id: this.dataset.sectionId,
            'resources[type]': 'product',
            'resources[limit]': '4',
            'resources[options][unavailable_products]': 'last',
          });

          try {
            const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.controller.signal });
            if (!response.ok) throw new Error(response.statusText);

            const html = await response.text();
            const markup = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('[data-predictive-results]');
            if (!markup) throw new Error('Missing predictive search results');

            this.cache.set(query, markup.innerHTML);
            this.render(markup.innerHTML);
          } catch (error) {
            if (error.name === 'AbortError') return;
            this.results.removeAttribute('aria-busy');
          }
        }

        render(html) {
          this.results.innerHTML = html;
          this.results.hidden = false;
          this.results.removeAttribute('aria-busy');
          this.results.scrollTop = 0;
          if (this.status) {
            this.status.textContent = this.results.querySelector('[data-search-count]')?.textContent.trim() || '';
          }
        }

        clear() {
          this.results.hidden = true;
          this.results.removeAttribute('aria-busy');
          this.results.replaceChildren();
          if (this.status) this.status.textContent = '';
        }
      }
    );
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      class StickyHeader extends HTMLElement {
        connectedCallback() {
          this.publishHeight = this.publishHeight.bind(this);

          this.resizeObserver = new ResizeObserver(this.publishHeight);
          this.resizeObserver.observe(this);
          this.publishHeight();

          if (!this.hasAttribute('data-sticky')) return;

          // The section pins at top: -1px, so the header stops being fully in
          // view at the exact moment it sticks. No scroll listener needed.
          this.intersectionObserver = new IntersectionObserver(
            ([entry]) => this.toggleAttribute('data-stuck', entry.intersectionRatio < 1),
            { threshold: [1] }
          );
          this.intersectionObserver.observe(this);

          if (this.dataset.sticky !== 'scroll-up') return;

          // Scroll direction is the one thing an observer cannot report, so this
          // mode alone listens to scroll — passively, and at most once a frame.
          this.lastScrollY = window.scrollY;
          this.onScroll = this.onScroll.bind(this);
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          this.intersectionObserver?.disconnect();
          window.removeEventListener('scroll', this.onScroll);
          cancelAnimationFrame(this.scrollFrame);
        }

        onScroll() {
          if (this.scrollFrame) return;

          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;

            // Clamped, so an overscroll bounce above the page is not read as
            // scrolling back down.
            const scrollY = Math.max(window.scrollY, 0);

            // Until the page has scrolled past the header, it is still sitting
            // in its own place and hiding it would leave a gap.
            if (scrollY <= this.offsetHeight) {
              this.removeAttribute('data-scroll-hidden');
              this.lastScrollY = scrollY;
              return;
            }

            // Small deltas are left to accumulate, so a jittery trackpad does
            // not flicker the header in and out.
            const delta = scrollY - this.lastScrollY;
            if (Math.abs(delta) < 8) return;

            const drawerOpen = this.querySelector('details[open]');
            this.toggleAttribute('data-scroll-hidden', delta > 0 && !drawerOpen);
            this.lastScrollY = scrollY;
          });
        }

        // Published on the root so the section below can offset itself by the
        // header's height without knowing anything about the header.
        publishHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* Only the video for the current breakpoint plays; the hidden one is paused. */
  class HeroMedia extends HTMLElement {
    connectedCallback() {
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.sync = this.sync.bind(this);
      this.mobileQuery.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.sync);
    }

    sync() {
      const activeClass = this.mobileQuery.matches ? 'hero__media-item--mobile' : 'hero__media-item--desktop';

      this.querySelectorAll('.hero__media-item').forEach((item) => {
        const isActive = item.classList.contains(activeClass);
        item.querySelectorAll('video').forEach((video) => {
          if (isActive) {
            video.play()?.catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }
  }

  if (!customElements.get('hero-media')) {
    customElements.define('hero-media', HeroMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load(url);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load(url) {
      let grid = null;

      try {
        const response = await fetch(url);
        if (response.ok) {
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          grid = doc.querySelector(
            `product-recommendations[data-section-id="${this.dataset.sectionId}"] [data-recommendations-grid]`
          );
        }
      } catch (error) {
        grid = null;
      }

      if (grid && grid.children.length > 0) {
        this.querySelector('[data-recommendations-grid]')?.replaceWith(grid);
        this.removeAttribute('data-loading');
      } else if (this.hasAttribute('data-loading')) {
        this.hidden = true;
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    const panel = event.target.closest('.stockists__panel');
    const radio = panel && document.getElementById(panel.dataset.radio);

    if (radio) radio.checked = true;
  });

  } catch(e) { console.error(e); }
})();
})();
